import { useContext } from 'react';
import { __RouterContext, RouteComponentProps, StaticContext } from 'react-router';

// https://github.com/ReactTraining/react-router/issues/6430
// delort me
// TODO: we might be able to use https://www.npmjs.com/package/use-react-router
export default function useRouter<P>(): RouteComponentProps<P, StaticContext, any> {
    return useContext<RouteComponentProps<P, StaticContext, any>>(
        (__RouterContext as unknown) as React.Context<RouteComponentProps<P, StaticContext, any>>
    );
}
